import { useState } from 'react';
import ReactDOM from 'react-dom';
import { Box, ButtonBase, Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { CloseIcon } from '../components/Icon';
import StyleInput from '../components/StyleInput';
import StyleButton from '../components/StyleButton';

const ID = `export_pwd_popup`;
const exportPwdExcel = (handleExport) => () => {
  const alertEl = document.createElement('div');
  alertEl.setAttribute('id', ID);
  document.getElementById('root').appendChild(alertEl);
  ReactDOM.render(<ExportDialog handleExport={handleExport} />, alertEl);
};

const ExportDialog = ({ handleExport }) => {
  const classes = useStyles();
  const [protectKey, setProtectKey] = useState('');
  const handleClose = () => {
    closeAlert(ID);
    closeAlert('ExportDialog');
  };
  return (
    <Dialog id="ExportDialog" className={classes.dislog} open={true}>
      <Box width="44.375rem" borderRadius="15px" p="2.56rem 1.88rem">
        <Box width="100%" display="flex" justifyContent="flex-end">
          <ButtonBase onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </ButtonBase>
        </Box>
        <Box>
          <div className={classes.password}>
            Password<span style={{ color: '#FF655C' }}>*</span>
          </div>
          <StyleInput width="100%" value={protectKey} onChange={setProtectKey} />
        </Box>
        <Box display="flex" width="100%" justifyContent="center" gridGap="1rem" mt="2rem">
          <StyleButton width="12.5rem" height="2.875rem" text="Cancel" onClick={handleClose} />
          <StyleButton
            type="fill"
            width="12.5rem"
            height="2.875rem"
            text="Export"
            disabled={protectKey?.length === 0}
            onClick={() => {
              handleClose();
              handleExport(protectKey);
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

const useStyles = makeStyles(() => ({
  dislog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
    },
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
  },
  password: {
    fontSize: '1rem',
    color: '#2E4469',
    marginBottom: '0.81rem',
  },
}));

const closeAlert = (ID) => {
  const targetEl = document.getElementById(ID);
  console.log('targetEl', targetEl);
  targetEl?.remove();
};

export default exportPwdExcel;
